import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type ConvertJobFragment = { jobScheduleId: string, status: Types.JobEntityStatusEnum, error?: string | null, mediaUrls: Array<{ url: string, format: string }>, meta?: { lessonMeta?: { refBlockId: string, pageBlockId: string, htmlUrl: string } | null } | null };


export type ConvertJobFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const ConvertJobFragmentDoc = /*#__PURE__*/ gql`
    fragment ConvertJob on JobType {
  jobScheduleId
  status
  mediaUrls {
    url
    format
  }
  meta {
    lessonMeta {
      refBlockId
      pageBlockId
      htmlUrl
    }
  }
  error
}
    `;